import { createFileRoute } from '@tanstack/react-router';
import { HistoryPage } from '@/components/custom/history-page';
import { websiteConfig } from '@/config/website';
import { m } from '@/locale/paraglide/messages';
import { seo } from '@/lib/seo';

export const Route = createFileRoute('/history')({
  head: () => {
    const siteName = websiteConfig.metadata?.name ?? '';
    const title = siteName
      ? `${m.history_title()} | ${siteName}`
      : m.history_title();
    return seo('/history', {
      title,
      description: m.history_meta_description(),
      indexable: false,
    });
  },
  component: HistoryPage,
});
